import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "gdprc-inner"
};
const _hoisted_2 = { class: "gdprc-container" };
const _hoisted_3 = { class: "gdprc-banner" };
const _hoisted_4 = { class: "gdprc-bannerIntro" };
const _hoisted_5 = {
    key: 0,
    class: "gdprc-bannerTitle"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
    key: 0,
    class: "gdprc-settings"
};
const _hoisted_8 = {
    class: "gdprc-settingsBody",
    ref: "settingsBody"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = { class: "gdprc-settingsList" };
const _hoisted_11 = ["checked", "disabled", "onChange"];
const _hoisted_12 = { class: "gdprc-fieldLabel" };
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("span", { class: "gg-check" }, null, -1);
import { computed, nextTick, onMounted, onUnmounted, reactive, ref, watch } from 'vue';
import { getPersistedConsentTypesList, persistConsentTypesList, userHasMadeAChoice } from './consent';
import { data, str } from './data';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConsentApp',
    setup(__props, { expose: __expose }) {
        const state = reactive({
            isVisible: false,
            settingsVisible: false,
            initialConsentTypes: [],
            acceptedConsentTypes: [],
        });
        const settingsBodyEl = ref(null);
        state.acceptedConsentTypes = getPersistedConsentTypesList();
        state.initialConsentTypes = state.acceptedConsentTypes.slice(); // clone
        onHashChange();
        window.addEventListener('hashchange', onHashChange);
        const backdropActive = computed(() => state.settingsVisible);
        __expose({
            open,
            close,
            toggle,
            get acceptedConsentTypes() {
                return state.acceptedConsentTypes;
            },
        });
        watch(() => state.isVisible, (val) => {
            if (val) {
                document.body.classList.add('gdprc--visible');
            }
            else {
                document.body.classList.remove('gdprc--visible');
            }
        });
        watch(() => state.settingsVisible, (val) => {
            if (val) {
                document.body.classList.add('gdprc--settingsVisible');
            }
            else {
                document.body.classList.remove('gdprc--settingsVisible');
            }
        });
        onMounted(() => {
            if (!userHasMadeAChoice()) {
                open();
            }
            window.addEventListener('resize', onWindowResize);
            window.addEventListener('orientationchange', onWindowResize);
        });
        onUnmounted(() => {
            window.removeEventListener('resize', onWindowResize);
            window.removeEventListener('orientationchange', onWindowResize);
            window.removeEventListener('hashchange', onHashChange);
        });
        function toggle() {
            state.isVisible ? close() : open();
        }
        function open() {
            state.isVisible = true;
        }
        function close() {
            if (window.location.hash === `#${data.anchor_hash}`) {
                history.replaceState({}, '', location.href.replace(`#${data.anchor_hash}`, ''));
            }
            state.isVisible = false;
        }
        function onHashChange() {
            if (window.location.hash === `#${data.anchor_hash}`) {
                open();
                nextTick(() => {
                    state.settingsVisible = true;
                });
            }
        }
        function onWindowResize() {
            if (state.settingsVisible && settingsBodyEl.value) {
                onSettingsEnter(settingsBodyEl.value);
            }
        }
        function acceptAllCookieTypes() {
            state.acceptedConsentTypes = data.consent_types;
            saveSettings();
        }
        function acceptOnlyRequiredCookies() {
            state.acceptedConsentTypes = data.consent_types.filter(ct => ct.required);
            saveSettings();
        }
        function saveSettings() {
            persistConsentTypesList(state.acceptedConsentTypes);
            state.settingsVisible = false;
            close();
        }
        function onCookieTypeChange(consentType) {
            if (state.acceptedConsentTypes.find(ct => ct.id === consentType.id)) {
                if (!consentType.required) {
                    state.acceptedConsentTypes = state.acceptedConsentTypes.filter(ct => ct.id !== consentType.id);
                }
            }
            else {
                state.acceptedConsentTypes = state.acceptedConsentTypes.concat(consentType);
            }
        }
        function onSettingsEnter(el) {
            el.style.height = el.scrollHeight + 'px';
        }
        function onSettingsLeave(el) {
            el.style.height = '';
        }
        function isConsentTypeAccepted(consentType) {
            return state.acceptedConsentTypes.findIndex(ct => ct.id === consentType.id) >= 0;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["gdprc", { 'is--settingsVisible': state.settingsVisible, 'is--backdropActive': backdropActive.value }])
            }, [
                _createElementVNode("div", {
                    class: "gdprc-backdrop",
                    onClick: _cache[0] || (_cache[0] = ($event) => (state.settingsVisible ? (state.settingsVisible = false) : close()))
                }),
                _createVNode(_Transition, { name: "gdprc" }, {
                    default: _withCtx(() => [
                        (state.isVisible)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("section", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            (_unref(str)('text', 'intro_title'))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(str)('text', 'intro_title')), 1))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", {
                                                class: "gdprc-bannerBody gdprc-richContent",
                                                innerHTML: _unref(str)('text', 'intro')
                                            }, null, 8, _hoisted_6)
                                        ]),
                                        _createElementVNode("footer", null, [
                                            _createElementVNode("button", {
                                                class: _normalizeClass(["gdprc-button is--hollow for--toggleSettings", { 'is--alt': state.settingsVisible }]),
                                                onClick: _cache[1] || (_cache[1] = ($event) => (state.settingsVisible = !state.settingsVisible))
                                            }, [
                                                _createElementVNode("span", null, _toDisplayString(_unref(str)('label', 'settings')), 1),
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(state.settingsVisible ? 'gg-chevron-up' : 'gg-chevron-right'),
                                                    "aria-hidden": "true"
                                                }, null, 2)
                                            ], 2),
                                            (_unref(data).enable_only_required_choice)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    class: "gdprc-button is--hollow for--onlyRequired",
                                                    onClick: _cache[2] || (_cache[2] = ($event) => (acceptOnlyRequiredCookies()))
                                                }, [
                                                    _createElementVNode("span", null, _toDisplayString(_unref(str)('action', 'accept_only_required')), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("button", {
                                                class: "gdprc-button for--acceptAll",
                                                onClick: _cache[3] || (_cache[3] = ($event) => (acceptAllCookieTypes()))
                                            }, [
                                                _createElementVNode("span", null, _toDisplayString(_unref(str)('action', 'accept_all')), 1)
                                            ])
                                        ])
                                    ]),
                                    _createVNode(_Transition, {
                                        name: "settings",
                                        onEnter: onSettingsEnter,
                                        onLeave: onSettingsLeave
                                    }, {
                                        default: _withCtx(() => [
                                            (state.settingsVisible)
                                                ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                                                    _createElementVNode("div", _hoisted_8, [
                                                        (_unref(str)('text', 'before_list'))
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 0,
                                                                class: "gdprc-richContent",
                                                                innerHTML: _unref(str)('text', 'before_list')
                                                            }, null, 8, _hoisted_9))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("ul", _hoisted_10, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).consent_types, (consentType) => {
                                                                return (_openBlock(), _createElementBlock("li", {
                                                                    key: consentType.id,
                                                                    class: _normalizeClass({ 'is--required': consentType.required })
                                                                }, [
                                                                    _createElementVNode("label", null, [
                                                                        _createElementVNode("input", {
                                                                            type: "checkbox",
                                                                            class: "gdprc-fieldInput",
                                                                            checked: consentType.required || isConsentTypeAccepted(consentType),
                                                                            disabled: consentType.required,
                                                                            onChange: ($event) => (onCookieTypeChange(consentType))
                                                                        }, null, 40, _hoisted_11),
                                                                        _createElementVNode("span", _hoisted_12, _toDisplayString(consentType.label), 1)
                                                                    ]),
                                                                    _createElementVNode("div", {
                                                                        class: "gdprc-richContent",
                                                                        innerHTML: consentType.description
                                                                    }, null, 8, _hoisted_13)
                                                                ], 2));
                                                            }), 128))
                                                        ]),
                                                        (_unref(str)('text', 'after_list'))
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 1,
                                                                class: "gdprc-richContent",
                                                                innerHTML: _unref(str)('text', 'after_list')
                                                            }, null, 8, _hoisted_14))
                                                            : _createCommentVNode("", true)
                                                    ], 512),
                                                    _createElementVNode("footer", null, [
                                                        _createElementVNode("button", {
                                                            class: "gdprc-button is--hollow for--saveSettings",
                                                            onClick: saveSettings
                                                        }, [
                                                            _createElementVNode("span", null, _toDisplayString(_unref(str)('action', 'save_settings')), 1),
                                                            _hoisted_15
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 2));
        };
    }
});
